// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Bb50Ocaj4YsB9mdO2Jqg{width:532px;min-width:492px;max-width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Bb50Ocaj4YsB9mdO2Jqg`
};
export default ___CSS_LOADER_EXPORT___;
